export default "__VITE_ASSET__BMjcZ2AM__"